/**
 * Interface representing the order information generated by the Unity WebGL app.
 */
interface IOrder {
    Name: string;
    LongName: string;
    ID: string;
    ProductID: string;
    Duplung?: {
        ProductID: string;
        PatternOriented: boolean;
        Fixing: "Gluing" | "Screwing";
    };
    BlockCutting?: {
        Name: string;
        BoardIndex: number;
        BoardCount: number;
    };
    Warning?: string;
    Width: number;
    Height: number;
    PatternOriented: boolean;
    Machinings: [];
    Edges?: {
        Left?: {
            ProductID: string;
        }
        Right?: {
            ProductID: string;
        }
        Top?: {
            ProductID: string;
        }
        Bottom?: {
            ProductID: string;
        }
    };
    Hardwares?: Array<{
        ProductID: string;
        ProductName: string;
        Position?: { X: number; Y: number; Z: number };
        Orientation?: string;
        ViewData?: { ps_product_reference: string; name: string; image: string | null };
    }>;
    minWidth: number;
    minHeight: number;
    Price: number;
    PriceDebug: number;
    sheetMaterialName: string;
    SheetPrice: number;
    UnitPrice: number;
    CutPrice: number;
    SheetWidth: number;
    SheetHeight: number;
    id_customization: number;
}

export default IOrder;
